import React from 'react';
import { Card, Skeleton } from 'antd';
import { SkTabsBar, SkTable } from './_primitives';

/** UserDetailPage — breadcrumb+back, profile card, 3+ tabs, transactions/orders tables */
const UserDetailPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    {/* Breadcrumb */}
    <div className="flex items-center gap-2 mb-4">
      <Skeleton.Button active size="small" style={{ width: 80 }} />
      <Skeleton.Input active size="small" style={{ width: 200 }} />
    </div>

    {/* Profile card with avatar + 3-column stats */}
    <Card className="shadow-sm mb-4">
      <div className="grid grid-cols-1 lg:grid-cols-[auto_1fr_auto] gap-6 items-center">
        <Skeleton.Avatar active size={96} shape="circle" />
        <div className="flex-1">
          <Skeleton.Input active size="large" style={{ width: 200, maxWidth: '100%', marginBottom: 8 }} />
          <Skeleton.Input active size="small" style={{ width: 240, maxWidth: '100%', marginBottom: 4 }} />
          <Skeleton.Input active size="small" style={{ width: 180, maxWidth: '100%' }} />
        </div>
        <div className="grid grid-cols-3 gap-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="text-center">
              <Skeleton.Input active size="small" style={{ width: 80, marginBottom: 6 }} />
              <Skeleton.Input active size="large" style={{ width: 60, height: 24 }} />
            </div>
          ))}
        </div>
      </div>
    </Card>

    {/* Tabs + table */}
    <Card className="shadow-sm">
      <SkTabsBar tabs={4} />
      <div className="overflow-x-auto">
        <SkTable rows={8} cols={6} inCard={false} />
      </div>
    </Card>
  </div>
);

export default UserDetailPageLoader;
